import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/ToggleSwitch' /* webpackChunkName: "ToggleSwitch" */),
    import(
      './viewer/ToggleSwitch.controller' /* webpackChunkName: "ToggleSwitch" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('ToggleSwitch', UiTypes),
};

export default entry;
